// import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useRouteMatch } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Container from '@material-ui/core/Container';
// import Grid from '@material-ui/core/Grid';

// Redux
import { setDataAlert } from "./../../../../@core/redux/actions/app/alert";
// import { openProfile } from "./../../../../@core/redux/actions/profile/index";
import { openGetCredit, openInviteFriend } from "./../../../../@core/redux/actions/affiliate/index";
import { setHomeMenuType } from "./../../../../@core/redux/actions/home/index";
import { setOpenWheelStatus } from "./../../../../@core/redux/actions/app/wheel";
// Hooks
import useParameterUrl from "./../../../../@utility/hooks/useParameterUrl";

// Component
// import AffiateApp from "./../pages/affiate/index";
// import LinkFriendApp from "./LinkFriend";
// import NavbarCredit from "./NavbarCredit";
// import Sidebar from "./Sidebar";
// import NavbarPromotion from "./NavbarPromotion";

// CSS
import styles from "./../assets/css/Style.module.css";

export default function NavbarMenu({ isUserLoggedIn, checkPageGameList }) {
    // const homeData = useSelector(state => state.reduxHome.result);
    const { path } = useRouteMatch();
    const history = useHistory();
    const dispatch = useDispatch();
    const reduxAppCMS = useSelector(state => state.reduxAppCMS.cms);
    const dataSetting = useSelector(state => state.reduxAppMenu.menu_items);
    const reduxAppScrollPosition = useSelector(state => state.reduxAppScrollPosition.top);
    // const [affiliate, setAffiliate] = useState({
    //     tab: "affiliate",
    //     show: false
    // });
    // const [linkFriend, setLinkFriend] = useState({
    //     show: false
    // });

    const parsed = useParameterUrl();
    const { play_game } = parsed;

    const useStyles = makeStyles((theme) => ({
        narbarPosition: {
            background: "var(--bt-info)",
            padding: "12px 10px 0px 10px",
            color: "var(--bt-defult)",
            [theme.breakpoints.down('xs')]: {
                padding: "4px 10px 4px 10px"
            }
        },
        menuList: {
            fontSize: "16px",
            cursor: "pointer",
            width: "140px",
            [theme.breakpoints.down('xs')]: {
                width: "72px"
            }
        },
        boxFlexCenter: {
            width: "100%",
            justifyContent: "center",
            [theme.breakpoints.down('sm')]: {
                width: "120vw",
            }
        },
        menuListSize: {
            width: "46px",
            background: "var(--bg-card)",
            padding: "10px",
            borderRadius: "100px",
            [theme.breakpoints.down('xs')]: {
                width: "28px",
                padding: "6px"
            }
        },
        menuListText: {
            fontSize: "18px",
            fontWeight: "500",
            marginTop: "4px",
            // color: reduxAppCMS !== null ? reduxAppCMS["bg-card"] : "white",
            [theme.breakpoints.down('xs')]: {
                marginTop: "0px",
                fontSize: "13px"
            }
        },
        boxProfile: {
            // width: "240px",
            borderRight: `1.5px solid ${reduxAppCMS !== null ? reduxAppCMS["bg-card"] : "#A954FF"}`,
            padding: "0px 40px 0px 0px",
            cursor: "pointer",
            [theme.breakpoints.down('sm')]: {
                width: "200px",
                padding: "0px 30px 0px 0px"
            },
            [theme.breakpoints.down('xs')]: {
                width: "135px",
                padding: "0px 15px 0px 0px"
            }
        },
        userSize: {
            width: "56px",
            height: "56px",
            // background: "#2F0363",
            border: `3px solid ${reduxAppCMS !== null ? reduxAppCMS["bg-main"] : "white"}`,
            borderRadius: "100%",
            [theme.breakpoints.down('sm')]: {
                width: "60px",
                height: "auto"
            },
            [theme.breakpoints.down('xs')]: {
                width: "36px",
                height: "auto"
            }
        },
        userLevelSize: {
            width: "46px",
            height: "auto",
            filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
            [theme.breakpoints.down('sm')]: {
                width: "36px",
                height: "auto"
            },
            [theme.breakpoints.down('xs')]: {
                width: "28px",
                height: "auto"
            }
        },
        usernameText: {
            fontSize: "18px",
            fontWeight: "600",
            paddingLeft: "8px",
            display: "inline-block",
            overflow: "hidden",
            color: reduxAppCMS !== null ? reduxAppCMS["bg-card"] : "white",
            [theme.breakpoints.down('xs')]: {
                fontSize: "14px",
                paddingLeft: "6px"
            }
        },
        levelText: {
            fontSize: "16px",
            fontWeight: "600",
            paddingLeft: "8px",
            color: reduxAppCMS !== null ? reduxAppCMS["bg-card"] : "white",
            [theme.breakpoints.down('xs')]: {
                fontSize: "12px",
                paddingLeft: "6px"
            }
        },
        levelMargin: {
            [theme.breakpoints.down('xs')]: {
                marginTop: "-4px"
            }
        }
    }));

    const classes = useStyles();

    const gotoPage = (item) => {
        let page = item.link;
        const typeAction = item.link_type;

        if (typeAction === 4) {
            if (page === "affiliate") {
                if (isUserLoggedIn === false) {
                    openBox("รับทรัพย์");
                }
                else {
                    dispatch(openGetCredit({
                        tab: "affiliate",
                        show: true,
                        type: null
                    }));
                }
            }
            else if (page === "inviteFrined") {
                if (isUserLoggedIn === false) {
                    openBox("เชิญเพื่อน");
                }
                else {
                    dispatch(openInviteFriend({
                        show: true
                    }));
                }
            }
            else if (page === "wheelSpin") {
                if (isUserLoggedIn === false) {
                    openBox("กงล้อลุ้นโชค");
                }
                else {
                    dispatch(setOpenWheelStatus(true));
                }
            }
        }
        else if (typeAction === 3) {
            let menuList = dataSetting.menu_camp;
            let dataObj = {};

            let index = menuList.findIndex(item => item.code === page);
            dataObj = menuList[index];
            dataObj.id = index;

            if (dataObj !== undefined && dataObj !== null) {
                dispatch(setHomeMenuType({
                    id: dataObj.id,
                    renderPage: dataObj.code,
                    pageTitle: dataObj.title,
                    game_camp_image: dataObj.game_camp_image,
                    column: {
                        desktop: dataObj.column_desktop,
                        mobile: dataObj.column_mobile
                    },
                    typeGame: dataObj.game_camp_type
                }));

                window.scrollTo({
                    top: reduxAppScrollPosition,
                    left: 0,
                    behavior: "smooth"
                });
            }
        }
        else if (typeAction === 1 && page !== "") {
            // ใส่ / ข้างหน้า ถ้ายังไม่มี
            page = page.startsWith("/") ? page : `/${page}`;
            window.location.href = page;
        }
        else {
            // ใส่ / ข้างหน้า ถ้ายังไม่มี
            if (page !== "") {
                page = page.startsWith("/") ? page : `/${page}`;
                history.push(page);
            }
        }
    };

    const openBox = (page) => {
        dispatch(setDataAlert({
            type: "warning",
            title: "แจ้งเตือน",
            text: `กรุณาเข้าสู่ระบบก่อนเข้าใช้งาน "${page}"`,
            action: true,
            redirect: "/login",
            show: true,
            buttonText: "ตกลง"
        }));
    };

    return (
        (play_game !== "true" && play_game !== true) && (
            <div className={checkPageGameList ? "navbarHome" : ""}>
                {/* {
                    isUserLoggedIn && (
                        <>
                            {
                                homeData !== null && (
                                    homeData.promotion_status === 1 && (
                                        <NavbarPromotion />
                                    )
                                )
                            }
                        </>
                    )
                } */}

                <div className={classes.narbarPosition}>
                    <Container maxWidth="lg" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                        <div className={[styles.menuPositionWidthScroll, styles.hideScrollbar].join(" ")} style={{ marginLeft: "0px", marginRight: "0px" }}>
                            <div className={["flexContent", classes.boxFlexCenter].join(" ")} style={{ alignItems: "center" }}>
                                {
                                    isUserLoggedIn && (
                                        dataSetting && (
                                            dataSetting?.menu_second && (
                                                dataSetting.menu_second.map((item) => {
                                                    return (
                                                        <div key={item.id}>
                                                            <div className={[classes.menuList, "center"].join(" ")} onClick={() => { gotoPage(item) }}>
                                                                <img className={classes.menuListSize} src={item.icon} alt=" เว็บออนไลน์ที่ให้บริการครบวงจร พร้อมโปรโมชั่นสุดพิเศษรองรับทุกการเสี่ยงโชค สมัครวันนี้รับโบนัสต้อนรับสูงสุด พร้อมระบบฝาก-ถอน อัตโนมัติที่รวดเร็วและปลอดภัยตลอด 24 ชม." />
                                                                <div className={classes.menuListText}>
                                                                    {
                                                                        item.name
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        )
    );
}